/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * RFC 9728 OAuth Protected Resource Metadata advertised by a remote MCP server. Only fields the dashboard renders are typed; the RFC allows additional members.
 */
export type ProtectedResourceMetadata = {
  /**
   * Authorization servers that can issue access tokens for this resource.
   */
  authorizationServers?: Array<string> | undefined;
  /**
   * Bearer token presentation methods accepted by the resource server.
   */
  bearerMethodsSupported?: Array<string> | undefined;
  /**
   * The resource server's identifier.
   */
  resource?: string | undefined;
  /**
   * URL of human-readable documentation for the resource server.
   */
  resourceDocumentation?: string | undefined;
  /**
   * Human-readable display name of the resource server.
   */
  resourceName?: string | undefined;
  /**
   * URL of the resource server's data-usage policy.
   */
  resourcePolicyUri?: string | undefined;
  /**
   * URL of the resource server's terms of service.
   */
  resourceTosUri?: string | undefined;
  /**
   * Scopes advertised by the resource server.
   */
  scopesSupported?: Array<string> | undefined;
};

/** @internal */
export const ProtectedResourceMetadata$inboundSchema: z.ZodMiniType<
  ProtectedResourceMetadata,
  unknown
> = z.pipe(
  z.object({
    authorization_servers: z.optional(z.array(z.string())),
    bearer_methods_supported: z.optional(z.array(z.string())),
    resource: z.optional(z.string()),
    resource_documentation: z.optional(z.string()),
    resource_name: z.optional(z.string()),
    resource_policy_uri: z.optional(z.string()),
    resource_tos_uri: z.optional(z.string()),
    scopes_supported: z.optional(z.array(z.string())),
  }),
  z.transform((v) => {
    return remap$(v, {
      "authorization_servers": "authorizationServers",
      "bearer_methods_supported": "bearerMethodsSupported",
      "resource_documentation": "resourceDocumentation",
      "resource_name": "resourceName",
      "resource_policy_uri": "resourcePolicyUri",
      "resource_tos_uri": "resourceTosUri",
      "scopes_supported": "scopesSupported",
    });
  }),
);

export function protectedResourceMetadataFromJSON(
  jsonString: string,
): SafeParseResult<ProtectedResourceMetadata, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ProtectedResourceMetadata$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ProtectedResourceMetadata' from JSON`,
  );
}
